import React from 'react';
import { CampaignList } from 'src/components/campaigns/CampaignList';
import { useDocumentTitle } from 'src/hooks/useDocumentTitle';

export const CampaignHome: React.FC = () => {
  useDocumentTitle('Campaigns - Leela');

  return <CampaignList />;
};
